import React from "react";
import { wrapIrSlots } from "../components/ads/irSlots";
import { AdfoxSticky } from "../components/adfoxBlocks/AdfoxSticky";
import { AdfoxBlock } from "../components/adfoxBlocks/AdfoxBlock";
import { splitNewsContent } from "../utils/adChunks";

function getAdfoxComponents(isFull, isDesktop, options) {
    return {
        1: <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={options.ir1} />,
        2: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir2} />,
        3: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir3} />,
        4: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir4} />,
        5: <AdfoxSticky isFull={isFull} isDesktop={isDesktop} options={options.ir5} />,
    };
}

function NewsText({ news, isFull, isDesktop, options, dbMode = false }) {
    const contentRef = React.useRef(null);
    const url = new URL(window.location.href);
    const chunks = splitNewsContent(news);
    const adfoxNum = chunks.filter((c) => c === "ADFOX").length;
    // Тизерных мест в этом шаблоне нет: в режиме БД json-запись ir-места не рисует ничего.
    const selectedComponentsMap = wrapIrSlots(getAdfoxComponents(isFull, isDesktop, options), {
        isFull,
        isDesktop,
        json: dbMode ? null : undefined,
    });
    let cnt = 1;

    const fullNewsUrl = new URL(url);
    if (fullNewsUrl.pathname.includes("preview/")) {
        fullNewsUrl.pathname = fullNewsUrl.pathname.replace(/\/(preview|news|preview\/news)\//, "full/");
    } else {
        fullNewsUrl.searchParams.set("view", "full");
    }

    return (
        <div className="newsDetail">
            <div className={!isFull ? "news-content-inner__toggle" : null} ref={contentRef}>
                {chunks.map((chunk, i) => {
                    if (chunk === "ADFOX" && cnt <= adfoxNum && isFull) {
                        cnt += 1;
                        return <React.Fragment key={`ad-${cnt - 1}`}>{selectedComponentsMap[cnt - 1]}</React.Fragment>;
                    }
                    if (i === chunks.length - 1) {
                        cnt = 1;
                    }
                    return (
                        <React.Fragment key={i}>
                            <p hidden={!isFull && chunk === "ADFOX"} dangerouslySetInnerHTML={{ __html: chunk }} />
                        </React.Fragment>
                    );
                })}
            </div>
            <div className={!isFull ? "toggleNews" : "hidden"}>
                <div className={!isFull ? "fadeNews" : null}></div>
                <a className={!isFull ? "openButton" : "hidden"} href={fullNewsUrl.toString()} target="_blank">
                    Показать больше
                </a>
            </div>
        </div>
    );
}

NewsText.defaultProps = {
    teasers: [],
};

export default NewsText;
